<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname"/>
    </div>
    <div class="content h-100 " style="background:white">
      <HomeVue v-if="page=='home'" @changePage="changePage" @mtdBackCampus="mtdBackCampus" />
      <PurchaseOrder v-if="page == 'ocompra'" @mtdChangePage="mtdChangePage" />
    </div>
    <div class="footer">
      <FooterVue @mtdChangePage="mtdChangePage" :pageView='page' />
    </div>
  </div>
</template>

<script>
import HomeVue from '@/components/Proveedor/Home.vue';
import Nav from "@/components/Proveedor/Nav.vue";
import FooterVue from '@/components/Proveedor/Footer.vue';
import PurchaseOrder from '@/components/Proveedor/Pages/PurchaseOrder.vue';

export default {
  name: "ProveedorView",
  components: {
    Nav,
    HomeVue,
    FooterVue,
    PurchaseOrder
  },
  props: {
    rolname: String,
  },
  data() {
    return {
      prefix: 'proveedor',
      page: 'home',
    };
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdChangePage: function(page){
      this.page = page;
    },
  },
};
</script>